module.exports = __webpack_public_path__ + "static/daily-mail-995fbcd8541a6fe229b8bca0f2f8b097.svg";